import { List } from "immutable"
import * as React from "react"
import { ButtonBlock, ButtonBlockProps } from "../components/button_block"
import { ExpandersBlock, ExpandersBlockProps } from "./expanders_block"
import { HighlightBlock, HighlightBlockProps } from "../components/highlight_block"
import { ImageBlock, ImageBlockProps } from "../components/image_block"
import { Container, Row } from "../components/library/container"
import { RichTextBlock, RichTextBlockProps } from "../components/rich_text_block"
import { VideoBlock, VideoBlockProps } from "../components/video_block"
import { ActivityClusterBlock, ActivityClusterBlockProps } from "./activity_cluster_block"
import { BooksBlock, BooksBlockProps } from "./books_block"
import { CollectionBlock, CollectionBlockProps } from "./collection_block"
import { ContentGridBlock, ContentGridBlockProps } from "./content_grid_block"
import { CarouselContentGridBlock, CarouselContentGridBlockProps } from "./carousel_content_grid_block"
import { FeaturedContentBlock, FeaturedContentBlockProps } from "./featured_content_block"
import { ImagesBlock, ImagesBlockProps } from "./images_block"
import { SubscriptionsBlock, SubscriptionsBlockProps } from "./subscriptions_block"
import { VacancyOverviewBlock, VacancyOverviewBlockProps } from "./vacancy_overview_block"
import { AsyncBlockProps, AsyncBlock } from "./async_block"
import { QuoteBlockProps, QuoteBlock } from "./quote_block"
import { CollectionSearchBar, CollectionSearchBarProps } from "./collection_search_bar"
import { GridBlock, GridBlockProps } from "./grid_block"
import { RecentNewsBlockProps } from "./recentNewsBlock/recentNewsBlockState"
import { RecentNewsBlock } from "./recentNewsBlock/recentNewsWidget"
import { FormstackBlock, FormstackBlockProps } from "./formstack/formstack_block"
import { IframeBlockProps } from "./iframeBlock/iframeBlockState"
import { IframeBlock } from "./iframeBlock/iframe_block"
import { CtaBlock, CtaBlockProps } from "./cta_block"
import { NewsletterFormBlock, NewsletterFormBlockProps } from "./newsletter_block"

export type Block =
  | { kind: "richText" } & RichTextBlockProps
  | { kind: "image" } & ImageBlockProps
  | { kind: "images" } & ImagesBlockProps
  | { kind: "content_grid" } & ContentGridBlockProps
  | { kind: "carousel_content_grid"} & CarouselContentGridBlockProps
  | { kind: "async_block" } & AsyncBlockProps<any>
  | { kind: "video" } & VideoBlockProps
  | { kind: "faq" } & ExpandersBlockProps
  | { kind: "expanders" } & ExpandersBlockProps
  | { kind: "knop" } & ButtonBlockProps
  | { kind: "highlight" } & HighlightBlockProps
  | { kind: "vacancy_overview" } & VacancyOverviewBlockProps
  | { kind: "books" } & BooksBlockProps
  | { kind: "collection" } & CollectionBlockProps
  | { kind: "featured_content" } & FeaturedContentBlockProps
  | { kind: "activity_cluster" } & ActivityClusterBlockProps
  | { kind: "subscription_block" } & SubscriptionsBlockProps
  | { kind: "quote" } & QuoteBlockProps
  | { kind: "collection_search_bar" } & CollectionSearchBarProps
  | { kind: "grid_block" } & GridBlockProps
  | { kind: "recent_news" } & RecentNewsBlockProps
  | { kind: "formstack_block" } & FormstackBlockProps
  | { kind: "iframe_block" } & IframeBlockProps
  | { kind: "cta_block" } & CtaBlockProps
  | { kind: "newsletterForm"} & NewsletterFormBlockProps
  | { kind: "empty" }

interface BlockRendererProps {
  readonly blocks: List<Block>
}

interface BlockRendererState {}

export class BlockRenderer extends React.Component<BlockRendererProps, BlockRendererState> {
  constructor(props: BlockRendererProps) {
    super(props)

    this.state = {}
  }

  render() {
    const { blocks } = this.props
    if (blocks.isEmpty()) return <></>

    return <div className="blocks">
      {blocks.map((b, i) => (
        <React.Fragment key={`block-${i}`}>
          {generateBlock(b)}
          <hr />
        </React.Fragment>
      ))}
    </div>
  }
}

export const generateBlock: (block: Block) => JSX.Element = b =>
  b.kind == "richText" ? ( // TH: Added to styleguide!
    <RichTextBlock {...b} />
  ) : b.kind == "image" ? ( // TH: Added to styleguide!
    <ImageBlock {...b} />
  ) : b.kind == "video" ? ( // TH: Added to styleguide!
    <VideoBlock {...b} />
  ) : b.kind == "faq" ? ( // TH: Added to styleguide!
    <ExpandersBlock {...b} />
  ) : b.kind == "expanders" ? ( // TH: Added to styleguide!
    <ExpandersBlock {...b} />
  ) : b.kind == "highlight" ? ( // TH: Added to styleguide!
    <HighlightBlock {...b} />
  ) : b.kind == "images" ? ( // TH: Added to styleguide!
    <ImagesBlock {...b} />
  ) : b.kind == "content_grid" ? ( // TH: Added to styleguide!
    <ContentGridBlock {...b} />
  ) : b.kind == "carousel_content_grid" ? ( // TH: Added to styleguide!
    <CarouselContentGridBlock {...b} />
  ) : b.kind == "async_block" ? ( // TH: ...
    <AsyncBlock {...b} />
  ) : b.kind == "knop" ? ( // TH: Added to styleguide!
    <ButtonBlock {...b} />
  ) : b.kind == "subscription_block" ? ( // TH: Added to styleguide!
    <SubscriptionsBlock {...b} />
  ) : b.kind == "vacancy_overview" ? ( // TH: Added to styleguide!
    <VacancyOverviewBlock {...b} />
  ) : b.kind == "books" ? ( // TH: Added to styleguide!
    <BooksBlock {...b} />
  ) : b.kind == "collection" ? ( // TH: Added to styleguide!
    <CollectionBlock {...b} />
  ) : b.kind == "featured_content" ? ( // TH: Added to styleguide!
    <FeaturedContentBlock {...b} />
  ) : b.kind == "activity_cluster" ? ( // TH: Added to styleguide!
    <ActivityClusterBlock {...b} />
  ) : b.kind == "quote" ? ( // TH: Added to styleguide!
    <QuoteBlock {...b} />
  ) : b.kind == "collection_search_bar" ? ( // TH: Added to styleguide!
      <section className="search-wrapper">
        <CollectionSearchBar {...b} />
      </section>
  ) : b.kind == "grid_block" ? ( // TH: Added to styleguide!
    <GridBlock {...b} />
  ) : b.kind == "recent_news" ? ( // TH: Added to styleguide!
    <RecentNewsBlock {...b} />
  ) : b.kind == "formstack_block" ? (
    <FormstackBlock {...b} />
  ) : b.kind == "iframe_block" ? ( //I also, added this to styleguide
    <IframeBlock {...b} />
  ) : b.kind == "cta_block" ? (
    <CtaBlock {...b} />
  ) : b.kind == "newsletterForm" ? (
    <NewsletterFormBlock {...b} />
  ) : <></>
  

{/* TH: Added to styleguide! */}
